import { Update } from "../components/merchant-type/Update";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/*
加盟店種別登録・更新
 */
const MerchantTypeRegister = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.MASTER_EDIT);
  return (
    <SpaceBetween size="l">
      <Update />
    </SpaceBetween>
  );
};

export default MerchantTypeRegister;
